import { ExpandButton } from 'mol-ui';
import isEmpty from 'lodash/isEmpty';
import { parseAppointmentType } from 'shared/utils';
import { turnsActions } from 'core/Turns';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonDiv,
    Content
} from './styled';
import {
    ListingItem,
    ListingLayout
} from 'views/components';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const AppointmentTypeListing = () => {

    const dispatch = useDispatch();
    const { push } = useHistory();
    const { listingCoverage } = useTheme();
    const { t } = useTranslation();
    const {
        appointmentTypes = [],
        appointmentTypesLoading: loading
    } = useSelector('turns');

    useEffect(() => {
        dispatch(turnsActions.getAppointmentTypes());
    }, []);
    
    const handleFilter = filter => {
        dispatch(turnsActions.getAppointmentTypes(filter));
    };

    const handleSelection = (mode, id) => {
        dispatch(turnsActions.setTurnsAppointmentType({}));
        push(`${ t('/consultas/tipos') }/${ mode }/${ id }`);
    };
    
    return (
        <ListingLayout
            loading={ loading }
            loadingText={ `${ t('Cargando tipos de consulta') }...` }
            searchBar={ false }
            onFilterChange={ handleFilter }
        >
            <Content>
                {
                    appointmentTypes
                        ? appointmentTypes.map(({
                            doctor,
                            duration,
                            id,
                            name,
                            specialties = [], type
                        }) => (
                            <ListingItem
                                color={ listingCoverage }
                                hideAvatar={ true }
                                key={ id }
                                text={ `
                                    ${ parseAppointmentType(type) } - ${ t('Duración') }: ${ duration } ${ t('minutos') }
                                    ${ !isEmpty(specialties) ? `${ t('Especialidad') }: ${ specialties.map(({ name }) => name).join(', ') }` : '' }
                                ` }
                                title={ `${ name }${ !!doctor ? ` (${ doctor.last_name }, ${ doctor.first_name })` : '' }` }
                                onActionClick={ mode => handleSelection(mode, id) }
                            />
                        ))
                        : <div>{ t('No hay coberturas') }...</div>
                }
            </Content>
            <ButtonDiv>
                <ExpandButton
                    caption={ t('Nuevo tipo de consulta') }
                    size={ 150 }
                    onClick={ () => push(t('/consultas/tipos/crear')) }
                />
            </ButtonDiv>
        </ListingLayout>
    );

};

export default AppointmentTypeListing;
